var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jp_w" },
    [
      _c(
        "div",
        { staticClass: "banner" },
        [
          _c("Banner"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav" },
            [_c("Nav", { attrs: { num: 5 } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("Search", { attrs: { type: 1 } }),
      _vm._v(" "),
      _c("Menus", {
        attrs: {
          courseList: _vm.courseList,
          meititype: _vm.meititype,
          yingyongtype: _vm.yingyongtype,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "courseL" }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(20, function (e) {
            return _c(
              "div",
              { staticClass: "listItem" },
              [_c("CourseItem", { attrs: { type: 3 } })],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "paginationX" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.leibie.current,
                "page-size": _vm.page.pageSize,
                layout: "prev, pager, next",
                total: _vm.total,
              },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }